import { render, staticRenderFns } from "./spreadIntranetManagement.vue?vue&type=template&id=1073322c&scoped=true"
import script from "./spreadIntranetManagement.vue?vue&type=script&lang=js"
export * from "./spreadIntranetManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073322c",
  null
  
)

export default component.exports